var config = require('../config');

module.exports = {
	parent: config.name,
    className: config.name + '--expanded'
};